import React from "react";
import GoogleMapReact from "google-map-react";
import "./map.css";
import LocationPin from "./LocationPin";
import {
  GoogleMap,
  MarkerF,
  CircleF,
  InfoWindowF,
  LoadScript,
} from "@react-google-maps/api";

function CustomMap({ mapData, setBackdrop = () => {}, fullScreen = false }) {
  const defaultProps = {
    center: {
      // convert to number
      lat: Number(mapData.lat),
      lng: Number(mapData.lng),
    },
    zoom: 18,
    address: mapData.address,
  };

  return (
    <LoadScript googleMapsApiKey="AIzaSyABgGCQG0a7LPPojOK7XLUP_65GavyZNKU" libraries={["places"]}>
      <div
        style={
          fullScreen
            ? { height: "100vh", width: "100%" }
            : { height: "70vh", width: "100%" }
        }
        className="customized-map"
      >
        <GoogleMap
          mapContainerStyle={{ height: "100%", width: "100%" }}
          center={defaultProps.center}
          zoom={defaultProps.zoom}
          options={{ mapTypeId: "satellite" }}
        >
          <LocationPin
            lat={defaultProps.center.lat}
            lng={defaultProps.center.lng}
            mapData={mapData}
            setBackdrop={setBackdrop}
            defaultProps={defaultProps}
          />
        </GoogleMap>
      </div>
    </LoadScript>
  );
}

export default CustomMap;
